<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link  class="text-inexorange hover:text-white" :href="route('organizations')">Comercio</inertia-link>
      <span class="text-white font-medium">/   {{ form.nameCommerce }}</span>
    </h1>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore">
      This organization has been deleted.
    </trashed-message>

    <div class="bg-transparent rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <file-input v-model="form.slider1" :error="form.errors.slider1" class="pb-8 pr-6 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen 1"/>
          <file-input v-model="form.slider2" :error="form.errors.slider2" class="pb-8 pr-6 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen 2"/>
          <file-input v-model="form.slider3" :error="form.errors.slider3" class="pb-8 pr-6 w-full lg:w-2/4" type="file" accept="image/*" label="Imagen 3"/>

        </div>
               <br>  
                <div v-if="mensagge" role="alert" class="mt-3 relative flex w-full p-3 text-sm text-white bg-black rounded-md">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-5 w-5 mr-2"><path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path></svg>
                {{mensagge}}
              </div>
              <br>  
        <div class="px-8 py-4 bg-transparent flex items-center">

         <loading-button :loading="form.processing" style="color: white;" class="px-8 py-4 btn-indigoOrange ml-auto" type="submit">ACTUALIZAR IMAGENES</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextAreaInput from '@/Shared/TextAreaInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Modal from '@/Shared/Modal.vue';

export default {
  metaInfo() {
    return { title: this.form.nameCommerce }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    TextAreaInput,
    Modal,
    FileInput,
  },
  layout: Layout,
  props: {
    organization: Object,
    wallets: Array,
  },
  remember: 'form',
  data() {
    return {
      envia: false,
      isModalVisible: false,
      mensagge: '',
      was: [],
      form: this.$inertia.form({
        _method: 'put',
        id: this.organization.id,
        nameCommerce: this.organization.nameCommerce,
       slider1: this.organization.slider1,
       slider2: this.organization.slider2,
       slider3: this.organization.slider3,

      }),
    }
  },
  methods: {
    update() {
this.form.post(`/organizations/${this.organization.id}`, {
        onSuccess: () => this.form.reset('slider1', 'slider2','slider3'),
      })      },
  },
}
</script>
